import { render, staticRenderFns } from "./MhDevInfos.vue?vue&type=template&id=5b661f14"
import script from "./MhDevInfos.vue?vue&type=script&lang=js"
export * from "./MhDevInfos.vue?vue&type=script&lang=js"
import style0 from "./MhDevInfos.vue?vue&type=style&index=0&id=5b661f14&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports